import type { IJsonModel } from 'flexlayout-react';

type Knoten = Record<string, any>;
export interface BrowserDateiKontext { haus?: 'dev' | 'partner'; origin?: string }
/** Only existing authenticated document renderers. This selects presentation, never access. */
export function browserDateiAdresse(config: Record<string, unknown>, kontext: BrowserDateiKontext): string | null {
  const pfad = config.datei ?? config.watchPath;
  const haus = config.haus ?? kontext.haus;
  if (typeof pfad !== 'string' || !pfad.startsWith('/') || pfad.startsWith('//') || pfad.includes('\\') || pfad.includes('\0')
    || pfad.split('/').some(p => p === '.' || p === '..') || !['dev', 'partner'].includes(String(haus))) return null;
  if (config.datei !== undefined && config.watchPath !== undefined && config.datei !== config.watchPath) return null;
  // An explicit account/partition belongs to another browsing context, not this file renderer.
  if (config.konto || config.partition || config.isolated) return null;
  const ext = /\.([a-z0-9]+)$/i.exec(pfad)?.[1].toLowerCase();
  const route = ext && ['pdf','png','jpg','jpeg','webp','gif','avif','mp3','m4a','wav','ogg','mp4','webm'].includes(ext) ? '/api/file'
    : ext && ['html','htm','txt'].includes(ext) ? '/api/file/download'
    : ext && ['md','mdx'].includes(ext) ? '/api/file/render-md' : null;
  // Office converters return JSON, not browser documents. Unknown types keep their existing viewer.
  if (!route) return null;
  const query = new URLSearchParams({path:pfad,haus:String(haus)});
  if (route === '/api/file/download') query.set('inline','1');
  const relative = `${route}?${query}`;
  if (!kontext.origin) return relative;
  try {
    const origin = new URL(kontext.origin);
    if (!['http:','https:'].includes(origin.protocol) || origin.username || origin.password || origin.origin !== kontext.origin) return null;
    return new URL(relative, origin).href;
  } catch { return null; }
}
function convertTab(node: Knoten, kontext: BrowserDateiKontext): void {
  if (node.type !== 'tab' || node.component !== 'preview') return;
  const config = node.config ?? {};
  const url = browserDateiAdresse(config, kontext);
  if (url) { node.component = 'browser'; node.config = { ...config, url }; }
}
/** Same renderer for a closed tab reopened into an existing model. */
export function browserStandardTab(tab: Knoten, kontext: BrowserDateiKontext): Knoten {
  const next = structuredClone(tab); convertTab(next, kontext); return next;
}
/** Apply after layout restoration: IDs, selected tabs and the saved preview content keys stay intact. */
export function browserStandard(doc: IJsonModel, kontext: BrowserDateiKontext): IJsonModel {
  const next = structuredClone(doc);
  const visit = (node: Knoten) => {
    convertTab(node, kontext);
    for (const child of node.children ?? []) visit(child);
  };
  visit(next.layout); for (const border of next.borders ?? []) visit(border);
  return next;
}
